import { TimeClockEntryKind, TimeCorrectionApplyMode } from '../types';

const LABELS: Record<TimeClockEntryKind, string> = {
  check_in: 'Entrada',
  check_out: 'Saída',
  lunch_out: 'Saída almoço',
  lunch_in: 'Volta almoço',
};

const APPLY_MODE_LABELS: Record<TimeCorrectionApplyMode, string> = {
  adjust_existing: 'Corrigir existente',
  add_extra: 'Hora extra',
};

export function formatTimeclockEntryKind(kind: TimeClockEntryKind): string {
  return LABELS[kind] ?? kind;
}

export function formatTimeclockApplyMode(mode?: TimeCorrectionApplyMode | null): string {
  if (!mode) return APPLY_MODE_LABELS.adjust_existing;
  return APPLY_MODE_LABELS[mode] ?? mode;
}
